// 2026-05-26 - FormuLearning - Step 4 §4.2 처방·용출 통합표
// 2026-07-20 수정 - 이슈 #42: f2(용액별 최솟값) 열 추가 + 배치별 용출 입력 그리드.
// 2026-07-21 수정 - 이슈 #43: 회차 단위 → **배치 단위**로 전환. 활성 Lot의 init+opti 전 배치를
//                   한 표에 두고(유형·회차 필터), 배치 식별자(batch_code)를 화면 정본으로 삼는다.
//                   제외는 유형·사유 모달을 거치며 복원은 1클릭이다(BR-S4-L02~L04·L12·L13).
// 2026-08-03 수정 - 이슈 #52: 표를 **전치**했다(행=excipient·열=batch, UI/UX v2.1 §5.8
//                   COMP-COMPONENT-TABLE 정본). 성분 수는 고정이고 배치는 늘어나므로 성분을
//                   세로에 고정해야 같은 성분을 배치 간 좌우로 비교할 수 있다. 행에 달려 있던
//                   조작 4종(선택·업로드·제외/복원·이력)은 열 헤더로 옮겼다 — 선택은 헤더·셀
//                   클릭, 나머지 3종은 `⋯` 팝오버다.
// 2026-08-03 수정 - 이슈 #53: 표 본체를 `ComponentTable.tsx`로 분리(500줄 기준 초과 해소).
//                   이 파일은 **조립과 상태 보유**만 맡는다 — Lot 배너·필터칩·표·f2 차트·
//                   Per-Batch 패널·모달을 엮고, 단일 선택과 조작 4종 핸들러를 쥔다.
// 2026-08-14 수정 - 이슈 #60(M84-18): 활성 Lot 배너·선택기 표기를 사용자 입력 표기(label)
//                   대체로. 종전의 `Lot N (label)` 괄호 병기는 대체 표시로 흡수된다.
// 2026-08-31 수정 - 이슈 #58 S5(#68): 성분표에 X 변수·총중량·조성 저장 핸들러를 내린다
//                   (`M84-09`·`10`·`62`). 데이터는 컨테이너가 쥐고 표시 컴포넌트는 받기만
//                   한다는 #53 구조 그대로다.
// 2026-08-31 수정 - 이슈 #58 S5 2차(#68): Per-Batch 블록을 정본 이름 **Sample Test Result**로
//                   세우고 `TestResultPanel`을 용출 그리드 위에 둔다(`M84-11`·`12`·`63`).
// 2026-08-31 수정 - 이슈 #58 S5 3차(#68): 배치 지정 업로드를 용출 그리드 **아래**로 내린다
//                   (`M84-14`·`27` — 직접 입력이 주 경로). 열 헤더 `⋯` 경로는 존치한다.
// 2026-08-31 수정 - 이슈 #58 S5 5차(#68, M84-75): **엑셀 업로드 진입점 전량 폐지.** 3차에서
//                   아래로 내린 그리드 업로드도, 존치했던 열 헤더 `⋯` 업로드도 걷는다
//                   (`BR-S4-L14`·`L16` 개정 · 사용자 결정 260831). 이로써 이 화면에
//                   업로드 경로가 남지 않는다 — 조성·Y 실측·용출 세 계열 모두 S5 1~4차로
//                   화면 입력 경로를 얻었기 때문이다. 백엔드 파서는 남는다.
// 2026-09-01 수정 - 이슈 #58 S10 2차(#70, M84-61): 표의 범위를 **라운드 하나**로 좁힌다
//                   (`COMP-COMPONENT-TABLE` 범위 v2.2 개정 · `COMP-ROUND-DROPDOWN`).
//                   유형·라운드 필터칩(`all`/`init`/`opti`/`R{n}`)은 걷었다 — 라운드가
//                   유형을 결정하므로(라운드는 initial 이거나 optimization 하나다) 칩이
//                   남으면 «빈 표» 조합만 만든다. **f2 추이 차트만 예외**로 전 배치를
//                   그대로 받는다(`COMP-F2-TREND-CHART` — 전 라운드를 가로지르는 그래프).
// 2026-09-01 수정 - 이슈 #58 S10 3차(#70, M84-13): 라운드별 처방표 다운로드를 성분표
//                   **아래**로 옮긴다(정본 §4.2). 종전에는 `NextOptimizationCard` 에
//                   있어 «어느 라운드의 처방표인가» 가 화면에서 멀었다 — `/prescription`
//                   은 `current_round_id` 를 따르므로 라운드를 고르는 자리 옆이 맞다.
// 2026-09-21 수정 - 이슈 #69(S6): ① 용출 비교 그래프를 Sample Test Result 에서 떼어 **§4.4 분석
//                   구획**(`DissolutionAnalysis` — 대조약 선택 + Run Analysis)으로 세운다(M84-24).
//                   ② 배치 선택기를 `BatchStepper` 로 빼서 결과 입력 머리와 분석 머리 **두 자리**에
//                   둔다 — 같은 선택 상태를 쓴다(M84-21 «선택 UI 를 중간중간»).
//                   ③ f2 추이 차트에 보고 있는 라운드를 넘긴다(구간 음영, M84-26).
// 2026-09-22 수정 - 이슈 #67 S4-2: 배너의 활성 Lot **선택기를 걷고 표시만** 한다 — Step 4 전환은
//                   `BR-LOT-08`(v1.10)이 폐기했고, 활성 Lot 이 Y 파생 기준이라(`BR-RND-05`) 여기서
//                   바꾸면 Step 4 가 Y 를 바꾸게 된다. 전환은 Step 3 탭 전용(UI/UX v2.5).
// 2026-09-24 수정 - 이슈 #76(G5): ① 용출 그리드 뼈대를 **배치 라운드의 격자 − 계산 제외**로 받는다(`referenceFor`,
//                   M901-29·30). ② 결과 저장(Y·조성·제외·복원)을 진행 수에 올리고 미저장 편집을 알린다 —
//                   저장 끝나기 전에는 Next Optimization 을 잠근다(M901-32, `step4PendingStore`).
// 2026-11-02 수정 - 이슈 #101(M1002-02·09): 선택 배치 조성 칩 — non-weight 는 **mg·다른 색**으로 % 합에서
//                   빼고, 중량 성분은 둘째 자리(합계 100.00 보정) + `Σ` 칩. 종전 칩은 non-weight 정제수까지
//                   `%` 로 보여 더하면 119.5% 가 됐다(AMBO-01).
// 2026-11-03 수정 - 이슈 #102: 성분표에 `runsAlgorithm`(User Define 칸 비우기)을 내리고, 조성 저장에 `null` 을 허용한다.
//                   선택 배치 조성 칩도 Step 3 X 순서로(M1002-07).
// 파일 위치: frontend/src/features/step4/IntegrationTable.tsx

import { useMemo, useState } from 'react'
import type { ReactNode } from 'react'
import type { DissolutionProfile, PhProfile } from '../../api/step3'
import {
  setBatchExcluded, saveBatchComposition, saveBatchResults, apiErrorDetail,
  lotDisplayName, type ExcludeType, type LotBatch, type LotListItem, type ReferenceLotCandidate,
} from '../../api/lot'
import type { XVariable, YVariable } from '../../api/step3'
import type { RoundListItem } from '../../api/round'
import DissolutionGrid from '../../components/DissolutionGrid'
import ComponentTable from './ComponentTable'
import { downloadFile } from '../../api/step4'
import TestResultPanel from './TestResultPanel'
import ExcludeDialog from './ExcludeDialog'
import BatchHistoryPanel from './BatchHistoryPanel'
import BatchF2Chart from './BatchF2Chart'
import RoundDropdown from './RoundDropdown'
import DissolutionAnalysis from './DissolutionAnalysis'
import { trackSave, useStep4Pending } from '../../stores/step4PendingStore'
import { NON_WEIGHT_MODE, orderByXVariables, pctDisplay, pctToMgText, xVariableIndex } from '../../lib/composition'

interface Props {
  projectId: string
  batches: LotBatch[]
  /** 지금 보고 있는 Lot 문맥 — 활성 Lot(#43). */
  lot: { activeLotNo: number; label: string; totalLots: number; hasReference: boolean }
  /** 표시 Lot 목록 — 배너가 활성 Lot 의 표기·측정일을 찾는 데 쓴다(전환은 Step 3 전용, #67 S4-2). */
  lots: LotListItem[]
  /** 라운드 목록 — `COMP-ROUND-DROPDOWN` 의 소스(M84-61). `round_no` 오름차순. */
  rounds: RoundListItem[]
  /** 보고 있는 라운드. 상위가 서버값(`current_round_id`)을 해석해 내려보낸다. */
  currentRoundId: string | null
  /** 라운드 전환 — 서버 상태를 바꾸므로 상위가 재조회까지 맡는다. */
  onSelectRound: (roundId: string) => Promise<void>
  /** 전환 왕복 중 — 드롭다운 중복 조작을 막는다. */
  roundBusy?: boolean
  /** f2 목표값 — 배치 f2 차트의 target 수평선(S-1). */
  targetValue: number | null
  /** 성분표 설정 범위 열·입력 제약의 근거(Step 3 §3.2, `M84-62`·`M84-10`). */
  xVariables: XVariable[]
  /** 성분표 `mg/T` 환산 기준(Step 3 §3.1, `M84-09`). */
  totalWeightMg: number | null
  /** Step 3 초기 설계 알고리즘 — User Define 이면 init 배치 칸을 비울 수 있다(#102 D4). */
  runsAlgorithm?: string | null
  /** 결과 입력 패널의 입력 칸 정의(Step 3 §3.3, `M84-12`). f2 행은 패널이 뺀다. */
  yVariables: YVariable[]
  /** 배치의 용출 입력 뼈대 — 그 라운드 격자에서 계산 제외를 뺀 대조약 프로파일(#76). */
  referenceFor: (batch: LotBatch) => PhProfile[]
  /** 분석 구획의 대조약 후보 — `COMP-REFERENCE-LOT-PICKER` 와 같은 집합(M84-24). */
  referenceCandidates: ReferenceLotCandidate[]
  /** 라운드별 처방표(`/prescription`) 경로 — 성분표 아래 다운로드 버튼(M84-13). */
  prescriptionHref: string
  /** 배치 저장 후 상위 상태(Step4 KPI·Step3 runs)를 다시 읽어온다. */
  onChanged: () => Promise<void>
  onSaveDissolution: (batch: LotBatch, profiles: DissolutionProfile[]) => Promise<void>
}

/**
 * 배치 선택기(`< 드롭다운 >`) — 보고 있는 라운드의 배치를 넘긴다. 결과 입력 머리와 분석 머리
 * 두 자리에 같은 선택 상태로 놓인다(M84-21). `testId` 로 두 자리를 가른다.
 */
function BatchStepper({ visible, selected, onSelect, testId }: {
  visible: LotBatch[]
  selected: LotBatch | null
  onSelect: (batchId: string) => void
  testId: string
}): ReactNode {
  const idx = selected ? visible.findIndex((b) => b.id === selected.id) : -1
  return (
    <div className="flex items-center gap-1">
      <button
        onClick={() => idx > 0 && onSelect(visible[idx - 1].id)}
        disabled={idx <= 0}
        className="rounded px-2 py-0.5 text-[11px] text-text-secondary hover:bg-bg-input disabled:opacity-30"
        style={{ border: '1px solid var(--border-subtle)' }}
        title="이전 배치"
      >
        &lt;
      </button>
      <select
        value={selected?.id ?? ''}
        onChange={(e) => onSelect(e.target.value)}
        data-testid={testId}
        className="rounded bg-bg-input px-1.5 py-0.5 text-[11px] text-text-body outline-none"
        style={{ border: '1px solid var(--border-soft)' }}
      >
        {visible.map((b) => (
          <option key={b.id} value={b.id}>
            {b.batch_code}{b.f2 != null ? ` · f2 ${b.f2.toFixed(1)}` : ''}
          </option>
        ))}
      </select>
      <button
        onClick={() => idx >= 0 && idx < visible.length - 1 && onSelect(visible[idx + 1].id)}
        disabled={idx < 0 || idx >= visible.length - 1}
        className="rounded px-2 py-0.5 text-[11px] text-text-secondary hover:bg-bg-input disabled:opacity-30"
        style={{ border: '1px solid var(--border-subtle)' }}
        title="다음 배치"
      >
        &gt;
      </button>
    </div>
  )
}

/** "YYYY-MM-DD" → "MM/DD" (배너·선택기 표시, BR-LOT-12). */
const fmtMMDD = (isoDate: string | null): string =>
  isoDate && /^\d{4}-\d{2}-\d{2}/.test(isoDate) ? `${isoDate.slice(5, 7)}/${isoDate.slice(8, 10)}` : ''

export default function IntegrationTable({
  projectId, batches, lot, lots, rounds, currentRoundId, onSelectRound,
  roundBusy, targetValue, xVariables, totalWeightMg, runsAlgorithm,
  yVariables, referenceFor, referenceCandidates, prescriptionHref, onChanged, onSaveDissolution,
}: Props) {
  const setPendingDirty = useStep4Pending((s) => s.setDirty)
  const [excluding, setExcluding] = useState<LotBatch | null>(null)
  const [history, setHistory] = useState<LotBatch | null>(null)
  // 2026-08-03 - 이슈 #50: 프로젝트 전체 이력 모달. 삭제된 배치의 이력은 여기서만 보인다.
  const [projectHistory, setProjectHistory] = useState(false)
  const [busy, setBusy] = useState(false)

  // 2026-07-23 - 이슈 #50 S-1·S-2: 표 열(#52 전치 전에는 행)·f2 차트 포인트·Per-Batch
  // 패널이 공유하는 단일 선택.
  const [selectedId, setSelectedId] = useState<string | null>(null)

  // 2026-09-01(#58 S10 2차, M84-61): 표의 범위는 **보고 있는 라운드**다. 종전 필터칩
  //   (`all`/`init`/`opti`/`R{n}`)이 하던 일을 `COMP-ROUND-DROPDOWN` 이 대신한다.
  //   라운드를 못 고른 상태(`currentRoundId = null`)에서는 좁히지 않는다 — 빈 표보다
  //   전 배치가 낫고, 상위가 마지막 라운드로 해석해 내려보내므로 실제로는 드문 경로다.
  const visible = useMemo(
    () => (currentRoundId ? batches.filter((b) => b.round_id === currentRoundId) : batches),
    [batches, currentRoundId],
  )

  // 선택은 **보고 있는 라운드 안에서** 성립한다(`COMP-BATCH-DROPDOWN` — 항목 = 그
  // 라운드의 배치). 라운드를 바꾸면 그 라운드의 첫 배치로 옮겨 간다.
  const selected = useMemo(
    () => visible.find((b) => b.id === selectedId) ?? visible[0] ?? null,
    [visible, selectedId],
  )

  // f2 추이 차트는 **전 라운드**를 그린다. 라운드 밖 포인트를 고르면 드롭다운이 그
  // 라운드로 따라간다(`COMP-ROUND-DROPDOWN` 연동 조항 · M84-26 의 라운드 전환분).
  // 따라가지 않으면 선택이 조용히 되돌아가 «눌리지 않는 점» 이 된다.
  const handleChartSelect = (batchId: string) => {
    setSelectedId(batchId)
    const b = batches.find((x) => x.id === batchId)
    if (b?.round_id && b.round_id !== currentRoundId) void onSelectRound(b.round_id)
  }

  const handleExcludeConfirm = async (type: ExcludeType, reason: string) => {
    if (!excluding) return
    await trackSave(async () => {
      await setBatchExcluded(projectId, excluding.id, true, type, reason)
      setExcluding(null)
      await onChanged()
    })
  }

  const handleRestore = async (batch: LotBatch) => {
    setBusy(true)
    try {
      await trackSave(async () => {
        await setBatchExcluded(projectId, batch.id, false)
        await onChanged()
      })
    } finally {
      setBusy(false)
    }
  }

  // 성분표 셀 편집 저장(`M84-09`, 인터페이스 v1.8 §2.10.4). 값은 % 단위다.
  // 422(범위·타입 위반)는 서버 사유를 그대로 알린다 — 조용히 되돌리면 왜 안 들어갔는지 모른다.
  const handleSaveComposition = async (batch: LotBatch, actualX: Record<string, number | null>) => {
    setBusy(true)
    try {
      await trackSave(async () => {
        await saveBatchComposition(projectId, batch.id, actualX)
        await onChanged()
      })
    } catch (err) {
      window.alert(apiErrorDetail(err) ?? '조성 저장에 실패했습니다.')
    } finally {
      setBusy(false)
    }
  }

  // 결과 입력 패널 저장(`M84-12`, 인터페이스 v1.9 §2.10.4). f2는 보내지 않는다.
  // 422(미정의 응답·f2 키·비수치)는 서버 사유를 그대로 알린다 — 조용히 되돌리면 왜 안
  // 들어갔는지 모른다(조성과 같은 규약).
  const handleSaveResults = async (batch: LotBatch, yValues: Record<string, number | null>) => {
    setBusy(true)
    try {
      await trackSave(async () => {
        await saveBatchResults(projectId, batch.id, yValues)
        await onChanged()
      })
    } catch (err) {
      window.alert(apiErrorDetail(err) ?? '결과 저장에 실패했습니다.')
    } finally {
      setBusy(false)
    }
  }

  const initCount = batches.filter((b) => b.batch_type === 'init').length

  // 선택 배치 조성 칩(M1002-02·09) — non-weight 판정은 Step 3 X 의 mode 다.
  const varOf = useMemo(() => xVariableIndex(xVariables), [xVariables])
  const isNonWeight = (k: string) => varOf(k)?.mode === NON_WEIGHT_MODE
  const selectedPct = selected ? pctDisplay(selected.x_values, isNonWeight) : null

  // 지금 보고 있는 Lot과, 값이 비어 보이는 이유를 한 줄로 알린다.
  // 2026-09-22(#67 S4-2): ~~선택기로 여기서도 활성 Lot을 전환한다(#50 F-8)~~ → 표시만 한다.
  const activeLot = lots.find((l) => l.lot_no === lot.activeLotNo)
  const lotBanner = (
    <div
      className="mb-2 flex flex-wrap items-center gap-x-3 gap-y-1 rounded px-2.5 py-1.5 text-[11px]"
      style={{ background: 'var(--color-bg-panel)', border: '1px solid var(--border-subtle)' }}
    >
      <span className="font-medium text-text-body">활성 Lot:</span>
      <span
        style={{ color: 'var(--color-accent-teal)' }}
        title="활성 Lot 은 Step 3 에서 바꿉니다 — Y 의 용출액별 f2 가 이 Lot 을 따릅니다"
        data-testid="active-lot-label"
      >
        {activeLot
          ? `${lotDisplayName(activeLot.label, activeLot.lot_no)}${activeLot.test_date ? ` · ${fmtMMDD(activeLot.test_date)}` : ''}`
          : lotDisplayName(lot.label, lot.activeLotNo)}
      </span>
      <span className="text-text-muted">
        전체 {lot.totalLots} Lot · init {initCount} · opti {batches.length - initCount}
      </span>
      {!lot.hasReference && (
        <span className="text-warn">
          ⚠ 대조약 용출 프로파일 미입력 — Step 3에서 입력하기 전에는 f2가 산출되지 않습니다.
        </span>
      )}
      {initCount === 0 && (
        <span className="text-warn">
          ⚠ Initial design 배치가 없습니다 — 위 Generate로 초기 설계점을 먼저 만드십시오.
        </span>
      )}
    </div>
  )

  if (batches.length === 0) {
    return (
      <div className="mb-4">
        <h4 className="mb-2 text-xs font-semibold uppercase tracking-wider text-text-secondary">
          Formulation &amp; Dissolution
        </h4>
        {lotBanner}
        <p className="text-[11px] text-text-secondary">
          No batches yet. Generate initial runs or request an optimization.
        </p>
      </div>
    )
  }

  return (
    <div className="mb-4">
      {lotBanner}

      {/* §4.2 Run Review — 성분표 **위**. 선택이 아래 표·결과 입력·분석의 대상을 바꾼다 */}
      <RoundDropdown
        rounds={rounds}
        currentRoundId={currentRoundId}
        onSelect={(rid) => void onSelectRound(rid)}
        busy={roundBusy}
      />

      <div className="mb-2 flex flex-wrap items-center gap-2">
        <h4 className="text-xs font-semibold uppercase tracking-wider text-text-secondary">
          Formulation &amp; Dissolution (per batch)
        </h4>
        <span className="text-[10px] text-text-muted" data-testid="batch-count">
          {visible.length}/{batches.length} batches · {batches.filter((b) => b.is_excluded).length} excluded
        </span>
        <button
          onClick={() => setProjectHistory(true)}
          className="rounded px-2 py-0.5 text-[10px] text-text-secondary transition-colors hover:bg-bg-input"
          style={{ border: '1px solid var(--border-subtle)' }}
          title="삭제된 배치의 이력까지 포함한 프로젝트 전체 액션 이력"
        >
          전체 이력
        </button>
      </div>

      {/* 성분표 — 행=excipient·열=batch(정본 §5.8). 조작·선택 상태는 이 파일이 쥔다(#53). */}
      <ComponentTable
        visible={visible}
        selected={selected}
        onSelect={setSelectedId}
        busy={busy}
        onExclude={setExcluding}
        onRestore={(b) => void handleRestore(b)}
        onHistory={setHistory}
        xVariables={xVariables}
        totalWeightMg={totalWeightMg}
        onSaveComposition={handleSaveComposition}
        runsAlgorithm={runsAlgorithm}
      />

      {/* 라운드별 처방표(M84-13) — 성분표 **바로 아래**(정본 §4.2). 대상은 보고 있는
          라운드이며 서버가 `current_round_id` 로 판정한다. `prescriptionUrl()` 은
          `/api/v1` 을 달고 오므로 벗겨 넘긴다(`downloadFile` 이 baseURL 을 붙인다). */}
      <div className="mb-2 flex justify-end">
        <button
          type="button"
          onClick={() => void downloadFile(prescriptionHref.replace('/api/v1', ''), 'prescription.xlsx')}
          data-testid="round-prescription-download"
          className="rounded border px-2.5 py-1 text-[10px] font-semibold text-text-body transition-opacity hover:opacity-90"
          style={{ borderColor: 'var(--border-purple)', backgroundColor: 'var(--bg-chip-purple)' }}
          title="이 라운드의 처방표(결과 입력 양식)를 내려받습니다"
        >
          ⬇ Formulation (.xlsx)
        </button>
      </div>

      {/* 배치별 f2 추이 — 표 바로 아래, 포인트↔열 상호 하이라이트(이슈 #50 S-1, P4-4) */}
      <BatchF2Chart
        batches={batches}
        currentRoundId={currentRoundId}
        selectedId={selected?.id ?? null}
        onSelect={handleChartSelect}
        targetValue={targetValue}
      />

      {/* §4.3 Sample Test Result — 단일 배치 선택(드롭다운 + < >)으로 게이팅(이슈 #50 S-2, P4-3).
          결과 입력 → 용출 입력표 → x·y 요약 순. 비교 그래프는 아래 §4.4 분석 구획(#69). */}
      <div className="mt-3">
        <div className="mb-2 flex flex-wrap items-center gap-2">
          <p className="text-[10px] font-semibold uppercase text-text-secondary">
            Sample Test Result (선택한 처방의 결과를 여기서 입력합니다)
          </p>
          <div className="ml-auto">
            <BatchStepper visible={visible} selected={selected} onSelect={setSelectedId} testId="batch-select" />
          </div>
        </div>

        {/* 2026-07-23 - 가로폭을 카드 오른쪽 끝까지(사용자 피드백) */}
        {selected && (
          <div className="w-full" style={{ opacity: selected.is_excluded ? 0.45 : 1 }}>
            {/* §4.3 결과 입력 — 배치 표시(M84-11)·Y 실측 입력(M84-12)·양식(M84-63) */}
            <TestResultPanel
              key={selected.id}
              batch={selected}
              yVariables={yVariables}
              onSave={(y) => handleSaveResults(selected, y)}
              busy={busy}
              onDirtyChange={(d) => setPendingDirty('y:table', d)}
            />

            <DissolutionGrid
              batchLabel={selected.batch_code}
              profiles={selected.dissolution_profiles}
              referenceProfiles={referenceFor(selected)}
              f2={selected.f2}
              f2BySolution={selected.f2_by_solution ?? {}}
              f2Reason={selected.f2_reason}
              onSave={(profiles) => onSaveDissolution(selected, profiles)}
              onDirtyChange={(d) => setPendingDirty('diss:table', d)}
            />

            {/* 선택 배치의 현재 x·y 값 요약 */}
            <div className="mt-2 rounded border p-2" style={{ borderColor: 'var(--border-subtle)' }}>
              <p className="mb-1 text-[10px] font-semibold uppercase text-text-secondary">
                {selected.batch_code} — Composition &amp; Results
              </p>
              <div className="flex flex-wrap gap-1.5">
                {orderByXVariables(Object.keys(selected.x_values), xVariables)
                  .filter((k) => !isNonWeight(k)).map((k) => [k, selected.x_values[k]] as const).map(([k, v]) => (
                  <span key={k} className="rounded px-1.5 py-0.5 text-[10px]"
                        style={{ background: 'var(--bg-chip-purple)', color: 'var(--color-text-body)' }}>
                    {k} <b>{selectedPct?.shown[k] ?? (typeof v === 'number' ? v.toFixed(2) : '—')}%</b>
                  </span>
                ))}
                {selectedPct && selectedPct.sum != null && (
                  <span className={`rounded px-1.5 py-0.5 text-[10px] ${selectedPct.sumOk ? '' : 'text-warn'}`}
                        style={{ border: '1px solid var(--border-purple)', color: selectedPct.sumOk ? 'var(--color-text-body)' : undefined }}
                        title="중량 성분(balance 포함) 합 — non-weight 는 mg 로만 관리해 뺍니다"
                        data-testid="composition-sum-chip">
                    Σ <b>{selectedPct.sumShown}%</b>
                  </span>
                )}
                {Object.entries(selected.x_values).filter(([k]) => isNonWeight(k)).map(([k, v]) => {
                  const mg = pctToMgText(v, totalWeightMg)
                  return (
                    <span key={k} className="rounded px-1.5 py-0.5 text-[10px] text-text-secondary"
                          style={{ border: '1px dashed var(--border-soft)' }}
                          title="selected(non-weight) — mg 로만 관리하며 % 합계에서 뺍니다">
                      {k} <b>{mg != null ? `${mg} mg` : '— mg'}</b>
                    </span>
                  )
                })}
              </div>
              <div className="mt-1.5 flex flex-wrap gap-1.5">
                {Object.entries(selected.y_values).map(([k, v]) => (
                  <span key={k} className="rounded px-1.5 py-0.5 text-[10px]"
                        style={{ background: 'var(--bg-chip-teal)', color: 'var(--color-accent-teal)' }}>
                    {k} <b>{typeof v === 'number' ? v.toFixed(1) : '—'}</b>
                  </span>
                ))}
                <span className="rounded px-1.5 py-0.5 text-[10px]"
                      style={{ background: 'var(--bg-chip-teal)', color: 'var(--color-accent-teal)' }}>
                  f2 (min) <b>{selected.f2 != null ? selected.f2.toFixed(1) : '—'}</b>
                </span>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* §4.4 분석 — 비교 대조약을 골라 용출 곡선·용액별 f2·판정을 본다(M84-23·24·25·65).
          머리에 배치 선택기를 한 번 더 둔다 — 위와 같은 선택 상태다(M84-21). */}
      {selected && (
        <DissolutionAnalysis
          projectId={projectId}
          batch={selected}
          candidates={referenceCandidates}
          batchPicker={
            <BatchStepper visible={visible} selected={selected} onSelect={setSelectedId}
                          testId="analysis-batch-select" />
          }
        />
      )}

      {excluding && (
        <ExcludeDialog
          targetLabel={excluding.batch_code}
          onConfirm={handleExcludeConfirm}
          onCancel={() => setExcluding(null)}
        />
      )}
      {history && (
        <BatchHistoryPanel
          projectId={projectId}
          batchId={history.id}
          batchCode={history.batch_code}
          onClose={() => setHistory(null)}
        />
      )}
      {/* 2026-08-03 - 이슈 #50: 프로젝트 전체 이력(삭제된 배치 포함) */}
      {projectHistory && (
        <BatchHistoryPanel projectId={projectId} onClose={() => setProjectHistory(false)} />
      )}
    </div>
  )
}
